import { TEMPLATES_WORKBENCH_COLUMN_ID } from "../constants";
import TemplatesTableDeploymentsCell from "./DeploymentsCell";
import TemplatesTableRowActionsCell from "./RowActionsCell";
import TemplatesTableSpaceCell from "./SpaceCell";
import TemplatesTableLabelsCell from "./LabelsCell";
import TemplatesTableNameCell from "./NameCell";
import TemplatesTableDescriptionCell from "./DescriptionCell";
import TemplatesLatestVersionCell from "./LatestVersionCell";

export const TEMPLATES_WORKBENCH_TABLE_CELLS = {
  [TEMPLATES_WORKBENCH_COLUMN_ID.NAME]: TemplatesTableNameCell,
  [TEMPLATES_WORKBENCH_COLUMN_ID.DESCRIPTION]: TemplatesTableDescriptionCell,
  [TEMPLATES_WORKBENCH_COLUMN_ID.LABELS]: TemplatesTableLabelsCell,
  [TEMPLATES_WORKBENCH_COLUMN_ID.LATEST_VERSION]: TemplatesLatestVersionCell,
  [TEMPLATES_WORKBENCH_COLUMN_ID.SPACE]: TemplatesTableSpaceCell,
  [TEMPLATES_WORKBENCH_COLUMN_ID.DEPLOYMENTS]: TemplatesTableDeploymentsCell,
  [TEMPLATES_WORKBENCH_COLUMN_ID.DROPDOWN]: TemplatesTableRowActionsCell,
};
